import { useSelector } from "react-redux";
import Avvvatars from "avvvatars-react";
import { Link } from "react-router-dom";
import { student_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";

const StudentDashboard = () => {
  const routes = student_routes;

  const userData = useSelector((state: any) => state.auth.user);
  const { selectedYear } = useAcademicYear();

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Tableau de bord</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Accueil</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Tableau de bord
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Page Header */}

          <div className="row">
            <div className="col-xxl-12">
              {/* Profile */}
              <div className="flex-fill">
                <div className="card bg-dark position-relative">
                  <div className="card-body">
                    <div className="d-flex align-items-center row-gap-3 mb-3">
                      <div className="avatar avatar-xxl rounded flex-shrink-0 me-3">
                        <Avvvatars
                          value={`${userData.firstname?.charAt(0) || ""}${userData.lastname?.charAt(0) || ""}`}
                          style="character" // ou "character"
                          size={70}
                        />
                      </div>
                      <div className="d-block">
                        <span className="badge bg-transparent-primary text-primary mb-1">
                          {userData.matricule}
                        </span>
                        <h3 className="text-truncate text-white mb-1">
                          {userData.firstname} {userData.lastname}
                        </h3>
                        <div className="d-flex align-items-center flex-wrap row-gap-2 text-gray-2">
                          <span className="border-end me-2 pe-2">
                            Classe :{" "}
                            {selectedYear?.Student?.Level?.abbreviation}{" "}
                            {selectedYear?.Student?.Class?.label}
                          </span>
                          <span>Année : {selectedYear?.label}</span>
                        </div>
                      </div>
                    </div>

                    <div className="student-card-bg">
                      <ImageWithBasePath
                        src="assets/img/bg/circle-shape.png"
                        alt="Bg"
                      />
                      <ImageWithBasePath
                        src="assets/img/bg/shape-02.png"
                        alt="Bg"
                      />
                      <ImageWithBasePath
                        src="assets/img/bg/shape-04.png"
                        alt="Bg"
                      />
                      <ImageWithBasePath
                        src="assets/img/bg/blue-polygon.png"
                        alt="Bg"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Profile */}
            </div>

            <div className="col-xxl-6">
              <div className="card">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h4 className="card-title">Liens Rapides</h4>
                </div>
                <div className="card-body pb-1">
                  <div className="row">
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.studentEDT}
                        className="d-block bg-success-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-success rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-success rounded-circle">
                            <i className="ti ti-calendar" />
                          </span>
                        </div>
                        <p className="text-dark">Emploi du Temps</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.studentCourse}
                        className="d-block bg-secondary-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-secondary rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-secondary rounded-circle">
                            <i className="ti ti-license" />
                          </span>
                        </div>
                        <p className="text-dark">Mes Cours</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.studentNote}
                        className="d-block bg-primary-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-primary rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-primary rounded-circle">
                            <i className="ti ti-hexagonal-prism" />
                          </span>
                        </div>
                        <p className="text-dark">Mes Notes</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.studentAttendance}
                        className="d-block bg-warning-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-warning rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-warning rounded-circle">
                            <i className="ti ti-calendar-share" />
                          </span>
                        </div>
                        <p className="text-dark">Absences</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.paymentList}
                        className="d-block bg-success-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-success rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-success rounded-circle">
                            <i className="ti ti-cash" />
                          </span>
                        </div>
                        <p className="text-dark">Paiements</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.requestList}
                        className="d-block bg-warning-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-warning rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-warning rounded-circle">
                            <i className="ti ti-file-text" />
                          </span>
                        </div>
                        <p className="text-dark">Demandes</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.myExams}
                        className="d-block bg-primary-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-primary rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-primary rounded-circle">
                            <i className="ti ti-hexagonal-prism" />
                          </span>
                        </div>
                        <p className="text-dark">Examens</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-1">
                      <Link
                        to={routes.myClaims}
                        className="d-block bg-danger-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-danger rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-danger rounded-circle">
                            <i className="ti ti-alert-circle" />
                          </span>
                        </div>
                        <p className="text-dark">Réclamations</p>
                      </Link>
                    </div>
                    <div className="col-6 col-md-4 mb-3">
                      <Link
                        to={routes.messagePage}
                        className="d-block bg-info-transparent ronded p-2 text-center mb-3 class-hover"
                      >
                        <div className="avatar avatar-lg border p-1 border-info rounded-circle mb-2">
                          <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-info rounded-circle">
                            <i className="ti ti-mail" />
                          </span>
                        </div>
                        <p className="text-dark">Mes messages</p>
                      </Link>
                    </div>
                  </div>
                </div>
                {/* </Slider> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentDashboard;
